import React from "react";

const AdvertiserSelectInfoMsg = () => (
  <div className="message-box">Please Select a Advertiser to begin.</div>
);

export default AdvertiserSelectInfoMsg;
